import React, { useEffect } from "react";
import ViewMaster from "../../Components/ViewMaster/ViewMaster";

function About() {
  useEffect(() => {
    document.title = "Zesty games | About Us";
  }, []);
  return (
    <>
      <div>
        <div className="bgContent" style={{ "background-color": "#ffffff" }}>
          <div className="container py-4 text-white fs-20">
            <div className="mb-4 txblack">
              <h4 className="DescriptionHeading"> About ZestyGame.com </h4>
              {/* <p>
                <strong>About ZestyGame.com</strong>
              </p> */}

              <p>
                Greetings from ZestyGame.com, your one-stop online gaming
                destination! With a vast collection of more than 1000 games in
                more than 25 categories, our goal is to provide customers with
                an outstanding gaming experience.
              </p>

              <p>
                At ZestyGame.com, we think that video games have the ability to
                unite people and generate enduring memories. We have something
                to offer everyone, regardless of their preference for
                exhilarating excursions, fast-paced races, or intense
                difficulties.
              </p>

              <p>
                <strong>Our Mission</strong>
              </p>

              <p>
                Our goal is to offer a flawless gaming experience that doesn't
                require downloads, logins, pop-ups, or other annoying features
                in order for gamers to start playing right away.
              </p>

              <p>
                We take pleasure in providing an easy-to-use platform with
                responsive interfaces and intuitive navigation so you can
                quickly get started playing your favorite games. We also place a
                high priority on your security and safety, taking precautions to
                safeguard your private information and guarantee a secure
                environment for all.
              </p>

              <p>
                <strong>Have any issue?</strong>
              </p>

              <p>
                Our professional support staff is available to offer you
                exceptional customer care. We are available to assist you if you
                run into any problems or have any inquiries. We value your input
                and always work to improve our platform based on your
                recommendations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewMaster(About);
